import { useEffect, useState } from "react";
import { router } from "@inertiajs/react";
import { createConsumer } from "@rails/actioncable";

interface SyncEvent {
  type: "sync_complete" | "sync_failed";
  records_upserted?: number;
  records_skipped?: number;
  completed_at?: string;
  message?: string;
}

export function useDncSync(onEvent?: (event: SyncEvent) => void) {
  const [syncing, setSyncing] = useState(false);
  const [lastEvent, setLastEvent] = useState<SyncEvent | null>(null);

  useEffect(() => {
    const consumer = createConsumer();
    const sub = consumer.subscriptions.create("DncSyncChannel", {
      received(data: SyncEvent) {
        setLastEvent(data);
        setSyncing(false);
        onEvent?.(data);

        if (data.type === "sync_complete") {
          router.reload();
        }
      },
    });

    return () => {
      sub.unsubscribe();
      consumer.disconnect();
    };
  }, []);

  return { syncing, setSyncing, lastEvent };
}
